export default "__VITE_ASSET__2cec2d94__"